// Список объектов МКД с богатым сайдбаром и фильтром по статусу из URL.
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Building2 } from 'lucide-react';
import { objectsApi } from '@/api';
import { AppLayout, PageHeader } from '@/components/layout/AppLayout';
import { RichSidebar } from '@/components/layout/RichSidebar';
import { Spinner } from '@/components/ui/Spinner';
import { StatusBadge } from '@/components/ui/StatusBadge';
import { EmptyState } from '@/components/ui/EmptyState';

const STATUS_LABEL: Record<string, string> = {
  active: 'Действующие', completed: 'Законченные', warranty: 'Гарантийные',
};
const STATUS_COLOR: Record<string, string> = {
  active: 'var(--blue)', completed: 'var(--green)', warranty: 'var(--yellow)',
};

export function ObjectsListPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const status = params.get('status') || undefined;

  const { data, isLoading } = useQuery({
    queryKey: ['objects', { status }],
    queryFn: () => objectsApi.list(status ? { status } : {}),
  });

  const title = status ? `Объекты — ${STATUS_LABEL[status] ?? status}` : 'Объекты МКД';

  return (
    <AppLayout sidebar={<RichSidebar />}>
      <PageHeader title={title} subtitle={data ? `${data.count} объектов` : undefined} />
      {isLoading ? <Spinner label="Загрузка объектов…" /> :
        !data || data.results.length === 0 ? (
          <EmptyState icon={<Building2 size={32} />} title="Объектов нет"
            hint={status ? 'В этом разделе пока пусто' : 'Объекты МКД появятся здесь'} />
        ) : (
          <div className="card-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))' }}>
            {data.results.map((obj) => (
              <div key={obj.id} className="card" onClick={() => navigate(`/objects/${obj.id}`)} style={{ cursor: 'pointer' }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start', justifyContent: 'space-between' }}>
                  <div style={{ display: 'flex', gap: 12, alignItems: 'flex-start' }}>
                    <div style={{ width: 38, height: 38, borderRadius: 'var(--radius-sm)', background: 'var(--blue-dim)', color: 'var(--blue)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      <Building2 size={18} />
                    </div>
                    <div>
                      <div style={{ fontWeight: 500, fontSize: 15 }}>{obj.address}</div>
                      <div style={{ color: 'var(--text-secondary)', fontSize: 13, marginTop: 4 }}>
                        {obj.constructs_count} конструктивов{obj.is_cultural_heritage && ' · ОКН'}
                      </div>
                    </div>
                  </div>
                  {obj.status && (
                    <StatusBadge label={STATUS_LABEL[obj.status] ?? obj.status}
                      color={STATUS_COLOR[obj.status] ?? 'var(--text-muted)'} />
                  )}
                </div>
              </div>
            ))}
          </div>
        )}
    </AppLayout>
  );
}
